var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    transform: "translate(-1024 -4295)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1024 4295)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.045,38.892h6.765V16.331H6.045ZM32.407,15.555A10.156,10.156,0,0,0,24.1,19.4V16.26H17.307V38.892H24.1V26.665a5.355,5.355,0,0,1,5.355-5.1c2.972,0,3.7,2.526,3.7,5.042v12.28h6.756v-12.8C39.912,17.188,35.691,15.555,32.407,15.555ZM9.4,14.082a3.391,3.391,0,1,0-2.4-.99A3.391,3.391,0,0,0,9.4,14.082Z",
    transform: "translate(-1029 -4300.3)",
    fill: "#e8eaea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d563ee22b1a484867435312e41a5c605.svg";
export { ForwardRef as ReactComponent };